module.exports = __webpack_public_path__ + "img/jxq-mobile.07e113df.png";